module.exports = __webpack_public_path__ + "img/icon-date2.5e54038e.svg";